// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--1jaN2","tag":"_93444fe79c--tag--3KnJX"};